import React from "react";
import { Flame } from "lucide-react";

const MENU = [
  { name: "BBQ Pizza", price: "$14" },
  { name: "BBQ Boat", price: "$14" },
  { name: "Pulled Pork Sandwich", price: "$14" },
  { name: "Japanese BBQ Burger", price: "$14" },
  { name: "Loaded Pork Fries", price: "$14" },
  { name: "Pork Crack Mash Bowl", price: "$10" },
  { name: "Nacho Jalapeño Pork Sandwich", price: "$10" },
  { name: "Japanese Pork Sandwich", price: "$10" },
  { name: "Mini Pulled Pork Sandwich", price: "$7" },
  { name: "Mini BBQ Boat", price: "$7" },
];

export default function MenuAd() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Fremont Menu Ad · 1080×1080
        </p>

        <div
          data-testid="menu-ad-card"
          className="relative w-[540px] h-[540px] overflow-hidden"
          style={{
            background:
              "radial-gradient(ellipse at 50% -10%, #2a0a08 0%, #0a0606 45%, #000 100%)",
          }}
        >
          {/* BBQ Boat hero image, big and bold on the right */}
          <div
            className="absolute"
            style={{
              top: -40,
              right: -130,
              width: 460,
              height: 460,
              backgroundImage: "url(/menu/bbq_boat.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "saturate(1.15) contrast(1.05)",
              maskImage:
                "radial-gradient(ellipse at center, black 55%, transparent 80%)",
              WebkitMaskImage:
                "radial-gradient(ellipse at center, black 55%, transparent 80%)",
              opacity: 0.55,
            }}
          />

          {/* Grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-25 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* Top brand bar */}
          <div className="absolute top-5 left-5 right-5 flex items-center justify-between z-10">
            <div className="flex items-center gap-2">
              <Flame
                className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
                style={{ width: 18, height: 18 }}
              />
              <span
                className="font-['Anton'] uppercase text-white tracking-[0.3em]"
                style={{ fontSize: 13 }}
              >
                Smokey <span className="text-[#FF3B30]">AF</span>
              </span>
            </div>
            <div
              className="bg-[#FF3B30] text-white font-['Anton'] uppercase tracking-wider px-3 py-1 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
              style={{ fontSize: 13 }}
            >
              City of Fremont
            </div>
          </div>

          {/* Headline */}
          <div className="absolute top-[60px] left-6 right-6 z-10">
            <div className="flex items-center gap-2 mb-3">
              <span className="h-px w-6 bg-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
                style={{ fontSize: 9 }}
              >
                Now Open
              </span>
            </div>
            <h1
              className="font-['Anton'] uppercase text-white leading-[0.82]"
              style={{ fontSize: 50, letterSpacing: "-0.02em" }}
            >
              Real BBQ.
              <br />
              <span style={{ color: "#FF3B30" }}>Right Here.</span>
            </h1>
            <p
              className="mt-2 font-['Outfit'] italic text-zinc-300"
              style={{ fontSize: 13 }}
            >
              Hand-pulled. Wood-fired. Honest as hell.
            </p>
          </div>

          {/* Menu list */}
          <div className="absolute left-6 right-6 z-10" style={{ top: 215 }}>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
              {MENU.map((item) => (
                <div
                  key={item.name}
                  className="flex items-baseline justify-between gap-2 border-b border-white/10 pb-0.5"
                >
                  <span
                    className="font-['Outfit'] uppercase text-white tracking-wider truncate"
                    style={{ fontSize: 10 }}
                  >
                    {item.name}
                  </span>
                  <span
                    className="font-['Anton'] text-[#FF8C00]"
                    style={{ fontSize: 13 }}
                  >
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom CTA strip */}
          <div className="absolute bottom-0 left-0 right-0 px-6 pb-5 z-10">
            <div
              className="bg-gradient-to-t from-black via-black/95 to-transparent absolute inset-x-0 bottom-0"
              style={{ height: 80 }}
            />
            <div className="relative flex items-center justify-between gap-3">
              <div>
                <div
                  className="font-['Outfit'] uppercase text-zinc-500 tracking-[0.3em]"
                  style={{ fontSize: 8 }}
                >
                  Inside Southern Style Bar
                </div>
                <div
                  className="font-['Anton'] uppercase text-white tracking-wider mt-0.5"
                  style={{ fontSize: 13 }}
                >
                  648 N Broad St · Fremont, NE
                </div>
              </div>
              <span
                className="font-['Anton'] tracking-widest uppercase bg-[#FF3B30] text-white px-3 py-2"
                style={{ fontSize: 11 }}
              >
                Order Online
              </span>
            </div>
            <div
              className="relative mt-2 text-center font-['Outfit'] uppercase text-zinc-500 tracking-[0.3em]"
              style={{ fontSize: 9 }}
            >
              smokey-af-bbq.emergent.host
            </div>
          </div>
        </div>

        <a
          href="/fremont-menu-ad.png"
          download
          data-testid="menu-ad-dl"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
